import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import setupApi, { getToken } from "@/api";
import router from "@/router/router";
import i18n from "@/plugins/i18n";
import layerStore from "@/store/modules/layerStore";
import plot from "@/store/modules/plot";
import meetnetStore from "@/store/meetnet";

import axios from "axios";
import VuexPersistence from "vuex-persist";
import { setInterceptors } from "@/services/interceptors";

const vuexLocal = new VuexPersistence({
  key: "vuex",
  storage: window.localStorage,
  modules: ["meetnetStore"],
});

Vue.use(Vuex);
function migrateCookieToLocalStorage() {
  if (localStorage.getItem("jwt") == null) {
    if (getToken()) {
      // coming from cookies
      localStorage.setItem("jwt", getToken());
      var cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }

      console.log("migrated token to localstorage");
    }
  }
}
// async function initializeToken() {
//   // let token = localStorage.getItem("jwt");
//   let token = getToken();
//   try {
//     await axios.post(`${process.env.VUE_APP_CAS_URL}/api-token-verify/`, {
//       token,
//     });
//     migrateCookieToLocalStorage();
//     return token;
//   } catch (err) {
//     var cookies = document.cookie.split(";");

//     for (var i = 0; i < cookies.length; i++) {
//       var cookie = cookies[i];
//       var eqPos = cookie.indexOf("=");
//       var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//       document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
//     }
//     localStorage.clear();
//     axios.get("/casclientinfo").then(
//       () => {
//         location.replace("/login");
//       },
//       (err) => {
//         router.push({ name: "loginView", params: { nextUrl: "/" } });
//       }
//     );
//   }
// }

// initializeToken();

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    config: {
      api_urls: {
        oss: process.env.VUE_APP_OSS_URL,
        ofs: process.env.VUE_APP_OSS_URL,
      },
      opacityLayers: [],
    },
    sharedApps: undefined,
    map: undefined,
    activeModule: undefined,
    language: "nl",
    timeRange: undefined,
    moduleTypes: ["staticLayer", "scenarios", "observations", "ais", "atlas"],
    observationsModuleTypeOptions: ["sensoren", "tsFallBackAll", "localTimes"],
    controlTypes: ["scale", "toolbox", "coordinates"],
    toolboxControlTypeOptions: [
      "layerInfo",
      "transectTool",
      "areaTool",
      "distanceTool",
    ],
    userData: {},
    token: getToken(),
    siteData: {},
    sensorsWithGroup: {},
    sensorGroups: {},
    echelon: false,
    // myApps: [
    //   {
    //     id: 1,
    //     name: "test01",
    //     description: "test01",
    //     ais: { project_id: 1, url: "https://ais.parkwind.imdcapps.be" }
    //   }
    // ]
  },
  getters: {
    opacityLayers: (state) => {
      return state.config.opacityLayers;
    },
    isAuthenticated: (state) => {
      return localStorage.getItem("jwt") !== null;
    },
    sensorsWithGroup: (state) => {
      return state.sensorsWithGroup;
    },
    sensorGroups: (state) => {
      return state.sensorGroups;
    },
    sensoren: (state) => {
      if (
        state.config &&
        state.config.observations &&
        state.config.observations.options &&
        state.config.observations.options.sensoren
      ) {
        return state.config.observations.options.sensoren;
      } else {
        return false;
      }
    },
    tsFallBackAll: (state) => {
      if (
        state.config &&
        state.config.observations &&
        state.config.observations.options &&
        state.config.observations.options.tsFallBackAll
      ) {
        return state.config.observations.options.tsFallBackAll;
      } else {
        return false;
      }
    },
    toolboxControlTypeOptions: (state) => (value) => {
      if (state?.config?.toolbox?.options) {
        if (state?.config?.toolbox?.options[value]) {
          return state.config.toolbox.options[value];
        } else {
          return false;
        }
      } else {
        return state?.config?.controls?.toolbox ? true : false;
      }
    },
  },

  mutations: {
    setEchelon: (state, val) => (state.echelon = val),

    setOpacity: (state, payload) => {
      if ("opacityLayers" in state.config) {
        let foundLayer = state.config.opacityLayers.find(
          (o) => o.id === payload.id
        );
        if (foundLayer) {
          let indexToDelete = state.config.opacityLayers.findIndex(
            (item) => item.id === payload.id
          );
          state.config.opacityLayers.splice(indexToDelete, 1);

          state.config.opacityLayers.push(payload);
        } else {
          state.config.opacityLayers.push(payload);
        }
      } else {
        state.config.opacityLayers = [payload];
      }
      // state.config.opacityLayers = [];
    },
    setLanguage: (state, payload) => (i18n.locale = _.lowerCase(payload)),
    setSharedApps: (state, payload) => (state.sharedApps = payload),
    setMyApps: (state, payload) => (state.myApps = payload),
    setConfig: (state, config) => (state.config = config),
    setMap: (state, map) => (state.map = map),
    setActiveModule: (state, val) => {
      state.activeModule = state.activeModule == val ? undefined : val;
    },
    setSensorsWithGroup: (state, payload) => {
      state.sensorsWithGroup = payload;
    },
    setSensorGroups: (state, payload) => {
      state.sensorGroups = payload;
    },
    setNonActiveModule: (state, val) => {
      state.activeModule = state.activeModule == val ? undefined : val;
    },
    clearState: (state) => {
      console.log("cleared");
      state.config = {};
      state.activeModule = undefined;
    },
    setTimeRange: (state, val) => (state.timeRange = val),
    setUserData: (state, userData) => (state.userData = userData),
    // setToken: (state, token) => {
    //   state.token = token;
    //   localStorage.setItem("jwt", token);
    // },
    clearToken: (state) => {
      var cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
      // state.token = false;
      localStorage.clear();
      location.href = `${process.env.VUE_APP_CAS_URL}/logout/?service=http://imdcapps.be/login/?service=https://sinapps.imdcapps.be/`;

      // axios.get("/casclientinfo").then(
      //   (res) => {
      //     // there is a login/logout page provided by casclient
      //     location.replace("/logout");
      //   },
      //   (err) => {
      //     router.push({ name: "loginView", params: { nextUrl: "/" } });
      //   }
      // );
    },
    setSiteData(state, payload) {
      state.siteData = payload;
    },
  },

  actions: {
    getConfig: ({ commit, dispatch }, id) => {
      return new Promise(async (resolve, reject) => {
        let api = setupApi(process.env.VUE_APP_CAS_URL + "/api");
        let data;
        try {
          ({ data } = await api.get(`imdc_apps/get_configuration/?id=${id}`));
          /*
          Set Meetnet Config
          */
          if (data?.config2?.meetnet) {
            setInterceptors(data.config2.meetnet.url);
            dispatch("setupMeetnet", {
              ...data.config2.meetnet,
              sinappsAppID: id,
            });
          }
        } catch (err) {
          console.error(err);
          router.push({ name: "appView" });
        }
        data.config2.id = id;
        commit("setConfig", data.config2);
        resolve(data.config2);
      });
    },
    async saveConfig({ commit }, config) {
      console.log("saveconfig");

      commit("setConfig", config);
      let api = setupApi(process.env.VUE_APP_CAS_URL);
      await api.post(`/api/imdc_apps/${config.id}/update_config/`, {
        config2: config,
      });
    },

    /*
    Region Site and Site Variables
    */
    getSiteData({ commit, state }, id) {
      new Promise(async (resolve, reject) => {
        let api = setupApi(state.config.api_urls.observations);
        let data;
        try {
          ({ data } = await api.get(`/api/site/${id}/`));
        } catch (err) {
          console.log("error getting site data", err);
        }
        commit("setSiteData", data);
        resolve(data);
      });
    },
    updateSiteData({ commit, state }, payload) {
      new Promise(async (resolve, reject) => {
        let api = setupApi(state.config.api_urls.observations);
        let data;
        let siteID = payload.id;
        delete payload.id;
        try {
          ({ data } = await api.patch(`/api/site/${siteID}/`, payload));
        } catch (err) {
          console.log("error updating site data", err);
        }
        commit("setSiteData", data);
        resolve(data);
      });
    },
    updateSiteVariableData({ state }, payload) {
      new Promise(async (resolve, reject) => {
        let api = setupApi(state.config.api_urls.observations);
        let data;
        let siteVariableID = payload.id;
        delete payload.id;
        try {
          ({ data } = await api.patch(
            `/api/sitevariable/${siteVariableID}/`,
            payload
          ));
        } catch (err) {
          console.log("error updating sitevariable data", err);
        }
        // commit("setSiteData", data);
        resolve(data);
      });
    },
  },
  modules: {
    layerStore,
    plot,
    meetnetStore,
  },
});
